import { Consultation } from '@/core/models/consultation.model'
import { SchillerPatient } from '@/core/classes/MedconnectDevicesAPI'

export type BiometricSource = 'mesures' | 'profile' | 'default'
export type BiometricInfo = {
  height: string
  weight: string
  heightSource: BiometricSource
  weightSource: BiometricSource
}

function getMesureValue(mesures: Consultation['mesures'], label: string): string | null {
  const m = mesures?.find((m) => m.label === label)
  if (m && m.value !== null && m.value !== '' && m.value !== 0 && m.value !== '0') {
    return m.value.toString()
  }
  return null
}

export function getPatientBiometrics(consultation: Consultation | undefined): BiometricInfo {
  const mesures = consultation?.mesures
  const patient = consultation?.patient

  // Height: prefer mesures 'Taille', then patient profile, then default 170
  const mesureHeight = mesures ? getMesureValue(mesures, 'Taille') : null
  const profileHeight = patient?.height ? patient.height.toString() : null
  const height = mesureHeight || profileHeight || '170'
  const heightSource: BiometricSource = mesureHeight ? 'mesures' : profileHeight ? 'profile' : 'default'

  // Weight: prefer mesures 'Poids', then patient profile, then default 70
  const mesureWeight = mesures ? getMesureValue(mesures, 'Poids') : null
  const profileWeight = patient?.weight ? patient.weight.toString() : null
  const weight = mesureWeight || profileWeight || '70'
  const weightSource: BiometricSource = mesureWeight ? 'mesures' : profileWeight ? 'profile' : 'default'

  return { height, weight, heightSource, weightSource }
}

export function buildDevicePatient(consultation: Consultation | undefined): SchillerPatient | null {
  const patient = consultation?.patient
  if (!patient) return null

  const { height, weight } = getPatientBiometrics(consultation)

  return {
    id: patient._id,
    name: patient.userInfo?.name,
    lastname: patient.userInfo?.surname,
    birthdate: patient.userInfo?.birthday || new Date('1/1/2000').toISOString(),
    gender: patient.userInfo?.gender ?? 'M',
    height,
    weight,
  }
}
